import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import RadioButton from '@nib-components/radio-button';
import BaseFormField from '../base-form-field';
import { CONTINUOUS_COVER_OPTIONS, CONTINUOUS_COVER_OPTIONS_MOBILE } from '../../util/constants';
import Select from '@nib-components/select';
import isMobile from 'is-mobile';
import styled from 'styled-components';
const StyledRadioButton = styled(RadioButton)`
  margin-left: -0.5rem;
  padding: 1.25rem;
`;
export const HELP_MESSGE = 'The number of years you have held Hospital cover affects your Lifetime Health Cover (LHC) loading.';
const ContinuousCover = props => {
  const {
    fieldLabel,
    value
  } = props;
  if (isMobile()) {
    return React.createElement(BaseFormField, {
      ...props,
      width: "100%"
    }, React.createElement(Select, {
      options: CONTINUOUS_COVER_OPTIONS_MOBILE,
      label: fieldLabel,
      help: HELP_MESSGE,
      value: value,
      placeholder: "Please select"
    }));
  } else {
    return React.createElement(BaseFormField, {
      ...props,
      width: "100%"
    }, React.createElement(RadioGroup, {
      options: CONTINUOUS_COVER_OPTIONS,
      label: fieldLabel,
      help: HELP_MESSGE,
      value: value,
      component: StyledRadioButton
    }));
  }
};
export default ContinuousCover;